<template>
  <div>
    <div class="actions row col-lg-12 mb-5 p-0 m-0 justify-content-end">
      <div class="actions-right row col-lg-6 row justify-content-end p-0 m-0">
        <button type="button" class="btn btn-primary" @click="addMembers">{{ $t('add') }}</button>
      </div>
    </div>
    <SearchBar @search-clicked="searchClicked"></SearchBar>
    <CTableWrapper ref="table" hover striped :caption="$t('members')" :items="items" :actions="actions" :pages="pages" :fields="fields" clickable-rows @row-clicked="rowClicked" @action-clicked="actionClicked" @update-requested="updateItemsRequested" :sorter="{external: true}" :sorterValue="sorterValue" @sorter-value-changed="sorterValueChanged" :loading="loading">
    </CTableWrapper>
    
    <!-- Modal de confirmação de exclusão -->
    <CModal
      :show.sync="showDeleteModal"
      :title="$t('confirmDelete')"
      color="primary"
    >
      <p>{{ $t('confirmRemove', { name: memberToDelete && memberToDelete.name ? memberToDelete.name : '' }) }}</p>
      <template #footer>
        <CButton @click="showDeleteModal = false" color="secondary">{{ $t('cancel') }}</CButton>
        <CButton @click="confirmDelete" color="primary" :disabled="deleting">
          <CSpinner v-if="deleting" size="sm" class="mr-1"></CSpinner>
          {{ $t('delete') }}
        </CButton>
      </template>
    </CModal>
  </div>
</template>
 
<script>
import { mapState, mapActions } from 'vuex'
import CTableWrapper from "@/controls/PaginatedTable.vue";
import SearchBar from "@/controls/SearchBar.vue";
import router from '@/router';
import InputGetList from "@/classes/InputGetList";
import i18n from '@/helpers/i18n';
import { convertToPascalCase } from "@/helpers/utils.js";

export default {
  components: { CTableWrapper, SearchBar },
  data () {
    return {
      searchText: '',
      itemsPerPage: localStorage.itemsPerPage ?? 10,
      fields: [
        { key: 'name', label: i18n.t('name'), _classes: 'font-weight-bold', sortable: true },
        { key: 'role', label: i18n.t('role'), sortable: false },
      ],
      actions: [
        { key: 'view', label: i18n.t('view') },
        { key: 'remove', label: i18n.t('remove') }
      ],
      sorterValue: { column: 'name', asc: true },
      loading: false,
      showDeleteModal: false,
      memberToDelete: null,
      deleting: false
    }
  },
  computed: {
    ...mapState('members', ['getMembersOutput']),
    ...mapState('members', ['deleteMemberByIdOutput']),
    membersInfo: function() {
      return this.getMembersOutput ? this.getMembersOutput : null;
    },
    items: function()
    {
      return this.membersInfo && this.membersInfo.data ? this.membersInfo.data : [];
    },
    pages: function()
    {
      return this.membersInfo ? this.membersInfo.totalPages : 1;
    }
  },
  mounted: function()
  {
    this.updateItemsRequested(1, this.itemsPerPage);
  },
  methods: {
    ...mapActions('members', ['getMembers']),
    ...mapActions('members', ['deleteMemberById']),
    rowClicked (item, index) {
      this.$router.push({name: "MembersEdit", query: { id: item.id }, params : { name: item.name } });
    },
    actionClicked(item, action){
      switch(action.key)
      {
        case 'view':
        {
          this.$router.push({name: "MembersEdit", query: { id: item.id }, params : { name: item.name } });
          break;
        }
        case 'remove':
        {
          this.openDeleteModal(item);
          break;
        }
        default:
        {
          throw "The provided action is not supported!"; 
        }
      }
    },
    updateItemsRequested(currentPage, itemsPerPage)
    {
      //Make request
      this.loading = true;
      this.itemsPerPage = itemsPerPage;

      var input = new InputGetList(itemsPerPage, currentPage, this.searchText, this.sorterValue.asc ? 1 : 2, convertToPascalCase(this.sorterValue.column));
      
      this.getMembers(input); 
    },
    addMembers () 
    {
      router.push({ name: 'MembersAdd'});
    },
    searchClicked(searchText)
    {
      this.searchText = searchText;
      this.$refs.table.reset();

      this.updateItemsRequested(1, this.itemsPerPage);
    },
    sorterValueChanged(value)
    {
      this.sorterValue = value;
    },
    openDeleteModal(item) {
      this.memberToDelete = item;
      this.showDeleteModal = true;
    },
    confirmDelete() {
      if (!this.memberToDelete) return;
      
      this.deleting = true;
      this.deleteMemberById(this.memberToDelete.id);
    }
  },
  watch:
  {
    sorterValue:
    {
      handler: function(val)
      {
        this.updateItemsRequested(1, this.itemsPerPage);
      },
      deep: true // Watch for changes on the properties
    },
    deleteMemberByIdOutput: function(val)
    {
      this.loading = true;
      this.deleting = false;
      this.showDeleteModal = false;
      this.memberToDelete = null;

      if(val)
      {
        this.updateItemsRequested(1, this.itemsPerPage);
      }
    },
    getMembersOutput: function(val)
    {
      if(val != null)
      {
        this.loading = false;
      }
    }
  }
}
</script>

 
<style>
th
{
  border-top: none !important;
}

tr
{
  cursor: pointer;
}

.status-button
{
  border: none;
  padding: 0;
  text-decoration: underline;
  color: #321fdb;
}
</style> 